export default function HotelsOptionsFactory(l10nService) {
    'ngInject';

            return {
                makeOptions: function(min, max, patterns) {
                    return _.map(_.range(min, max + 1), function(index) {
                        return {
                            text: pluralize(index, patterns),
                            value: index.toString(),
                        };
                    });
                },

                getRatesLabels: function() {
                    return makeObjectLocalized({
                        0: 'Standard rate',
                        1: 'Corporate rate',
                        2: 'Promotional rate',
                        3: 'Senior citizen rate',
                        4: 'Stopover rate',
                        5: 'Military rate',
                        6: 'Travel industry rate',
                        7: 'Government rate',
                        8: 'Tour rate',
                        9: 'Weekend rate',
                        10: 'Convention rate',
                        11: 'Package rate',
                        12: 'Family rate',
                        13: 'B&B rate',
                        14: 'CRS rate',
                        15: 'AAA rate',
                        16: 'Senior citizen rate',
                        17: 'AARP/Senior rate',
                    });
                },
            };

            function makeObjectLocalized(labels) {
                return _.transform(labels, function(result, value, key) {
                    result[key] = l10nService.localize(value);
                });
            }

            function pluralize(value, patterns) {
                const pattern = patterns[value] || patterns.other || '{}';
                return pattern.replace('{}', value);
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/services/hotelsOptions.js